<div class="flex h-full min-h-0 flex-col flex-1 overflow-y-auto scrollbar-transparent gap-y-4 py-1">

    @if (isLoading()) {
    <div class="flex flex-1 items-center justify-center py-16">
        <svg aria-hidden="true" class="size-8 text-gray-300 animate-spin dark:text-gray-600 fill-primary"
            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor" />
            <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill" />
        </svg>
    </div>

    } @else if (!agency()?.stripeCustomerId || !subscription()) {
    <div class="flex flex-1 items-center justify-center py-16">
        <p class="text-sm text-secondary m-0">No subscription found for this agency.</p>
    </div>

    } @else if (subscription(); as sub) {

    <div class="rounded-lg border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-800/50 px-4 py-4 flex items-center justify-between">
        <div>
            <p class="text-xs font-medium text-secondary uppercase tracking-wide m-0">Subscription</p>
            <p class="mt-1 text-sm font-semibold text-primary m-0">{{ basePlanName(sub) }}</p>
        </div>
        <p class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset m-0"
            [class]="getStatusClass(sub.status)">
            {{ getStatusLabel(sub.status) }}
        </p>
    </div>

    <div class="rounded-lg border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-800/50 overflow-hidden">
        <div class="px-4 py-3 border-b border-gray-200 dark:border-zinc-700 flex items-center justify-between">
            <div>
                <h3 class="text-sm font-semibold text-primary m-0">Bolt-ons</h3>
                <p class="text-xs text-secondary mt-0.5 m-0">{{ boltOns(sub).length }} active</p>
            </div>
        </div>

        @if (boltOns(sub).length === 0) {
        <div class="px-4 py-8 text-center">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"
                class="mx-auto size-8 text-gray-300 dark:text-gray-600">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    stroke-width="2" vector-effect="non-scaling-stroke" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
            <p class="mt-2 text-sm text-secondary m-0">No bolt-ons active</p>
        </div>
        } @else {
        <ul role="list" class="divide-y divide-gray-100 dark:divide-zinc-700">
            @for (item of boltOns(sub); track item.id) {
            <li class="flex items-center justify-between gap-x-4 px-4 py-3">
                <div class="flex items-center gap-x-3 min-w-0">
                    <div
                        class="shrink-0 size-8 rounded-lg bg-zinc-100 dark:bg-zinc-700 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4 text-zinc-500 dark:text-zinc-300" aria-hidden="true">
                            <path
                                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                        </svg>
                    </div>
                    <div class="min-w-0">
                        <p class="text-sm font-medium text-primary truncate m-0">{{ boltOnName(item) }}</p>
                        <p class="text-xs text-secondary m-0">{{ getBillingPeriod(item) }}</p>
                    </div>
                </div>
                <p class="shrink-0 text-sm font-medium text-primary m-0">
                    {{ getBoltOnPrice(item) | currency: getCurrencyCode(sub) }}
                </p>
            </li>
            }
        </ul>
        }
    </div>

    }
</div>
